import { SearchUser } from 'lib-search-types';
import { MetaConversation } from 'lib-shared-legacy-types';

import { ajaxSend } from '../../../../api/api';

// Get queue by id
export function assistedTransferRequest(payload: {
  metaConversation: MetaConversation;
  requestToUser: SearchUser;
  sourceContactPointValue: string;
}) {
  const { metaConversation, requestToUser, sourceContactPointValue } = payload;
  return ajaxSend({
    method: 'PUT',
    path: `/v1/conversations/${metaConversation.conversation.id}/transfer/assisted`,
    data: {
      to: requestToUser.id,
      sourceContactPointValue,
    },
  });
}

export function assistedTransferResolve(payload: {
  metaConversation: MetaConversation;
  accepted: boolean;
}) {
  const { metaConversation, accepted } = payload;
  return ajaxSend({
    method: 'PUT',
    path: `/v1/conversations/${metaConversation.conversation.id}/transfer/assisted/resolve`,
    data: {
      accepted: accepted,
    },
  });
}

export function blindTransferRequest(payload: {
  metaConversation: any;
  requestToUser: SearchUser;
  sourceContactPointValue: string;
}) {
  const { metaConversation, requestToUser, sourceContactPointValue } = payload;
  return ajaxSend({
    method: 'PUT',
    path: `/v1/conversations/${metaConversation.conversation.id}/transfer/blind`,
    data: {
      to: requestToUser.id,
      entity: 'number',
      sourceContactPointValue,
    },
  });
}
